export interface NakomisHomeConfig {
    env: string;
    aws: { region: string };
    cognito: {
        authority: string;
        userPoolId: string;
        userPoolClientId: string;
        cognitoDomain: string;
        redirectUri: string;
        logoutUri: string;
    };
    api: { apiUrl: string };
    /** Optional - only present once the chatbot Lambda Function URL (HOME-233) has been deployed and recorded in SSM. Named `functionUrl` (not `apiUrl`) so set-config.sh's global sed doesn't collide it with api.apiUrl. */
    chat?: { functionUrl: string };
}

import configJson from './config.json';

const Config: NakomisHomeConfig = configJson as NakomisHomeConfig;

export default Config;
